import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { ICountryApi } from "./base/countryApi";
import { Result } from "../models/common/resultResponse";
import { KeyValueDefaultEnum } from "../models/common/keyValueDefaultEnum";
import { CountryPublicResponse } from "../models/response";
import { CountryByVehicleFilterRequest } from "../models/request";

const baseRoute: string = "Country";

export class CountryApi extends ICountryApi {
	getPublicDomain(): Promise<AxiosResponse<Result<CountryPublicResponse[]>, any>> {
		return api.get(`${baseRoute}/countrydomain_public`);
	}
	getDomain(idUser: string | null): Promise<AxiosResponse<Result<CountryPublicResponse[]>>> {
		if (idUser !== null) {
			return api.get(`${baseRoute}/domain`, { params: { idUser } });
		}
		return api.get(`${baseRoute}/domain`);
	}

	getDomainByVehicles(filter?: CountryByVehicleFilterRequest): Promise<AxiosResponse<Result<KeyValueDefaultEnum[]>>> {
		return api.get(`${baseRoute}/domainbyvehicles`, { params: filter });
	}
}
